import React from 'react';
import { sans, mono, green, greenLight, greenDark, red, redLight, redDark, amberLight, amberDark, useTheme, useCurrency } from '../tokens';
import { fmtC } from '../helpers';

function VarianceIndicator({ level }) {
  const styles = {
    normal: { bg: greenLight, color: greenDark, label: 'Normal' },
    warning: { bg: amberLight, color: amberDark, label: 'Warning' },
    abnormal: { bg: redLight, color: redDark, label: 'Abnormal' },
  };
  const s = styles[level];
  return (
    <span style={{
      fontSize: 10, padding: '2px 8px', borderRadius: 12, fontWeight: 600,
      background: s.bg, color: s.color, fontFamily: sans,
    }}>
      {s.label}
    </span>
  );
}

export default function PLVarianceAnalysis({ glHistory, currentLabel }) {
  const t = useTheme();
  const cc = useCurrency();
  return (
    <div style={{ overflowX: 'auto' }}>
      <div style={{ fontSize: 12, color: t.textSecondary, marginBottom: 12 }}>
        Each GL account compared against its rolling average. Flags accounts outside normal range.
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: sans }}>
        <thead>
          <tr style={{ borderBottom: `2px solid ${t.border}` }}>
            {['Account', `Current (${currentLabel || 'Feb'})`, 'Avg', 'Var $', 'Var %', 'Status'].map((h, i) => (
              <th key={h} style={{
                textAlign: i === 0 ? 'left' : 'right', padding: '8px 10px',
                fontSize: 10, color: t.textMuted, textTransform: 'uppercase', letterSpacing: 0.6,
                fontWeight: 600, fontFamily: sans,
              }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {glHistory.map(account => {
            if (account.monthly.length === 0) return null;
            const current = account.monthly[account.monthly.length - 1];
            const avg = account.monthly.reduce((s, v) => s + v, 0) / account.monthly.length;
            const diff = current - avg;
            const pctVar = avg !== 0 ? (diff / avg) * 100 : 0;
            const absPct = Math.abs(pctVar);

            const isExpense = ['5', '6', '7'].includes(account.code[0]);
            const isBadDirection = isExpense ? diff > 0 : diff < 0;

            let level = 'normal';
            if (absPct > 30 && isBadDirection) level = 'abnormal';
            else if (absPct > 15 && isBadDirection) level = 'warning';

            const varColor = diff === 0 ? t.textFaint : isBadDirection ? red : green;

            return (
              <tr key={account.code} style={{ borderBottom: `1px solid ${t.borderLight}` }}>
                <td style={{ padding: '8px 10px' }}>
                  <span style={{ color: t.textPrimary, fontSize: 13 }}>{account.name}</span>
                  <span style={{ color: t.textFaint, fontSize: 11, marginLeft: 8, fontFamily: mono }}>{account.code}</span>
                </td>
                <td style={{ textAlign: 'right', padding: '8px 10px', fontFamily: mono, fontSize: 12, color: t.textPrimary }}>
                  {fmtC(current, cc)}
                </td>
                <td style={{ textAlign: 'right', padding: '8px 10px', fontFamily: mono, fontSize: 12, color: t.textMuted }}>
                  {fmtC(Math.round(avg), cc)}
                </td>
                <td style={{ textAlign: 'right', padding: '8px 10px', fontFamily: mono, fontSize: 12, color: varColor }}>
                  {fmtC(Math.round(diff), cc)}
                </td>
                <td style={{ textAlign: 'right', padding: '8px 10px', fontFamily: mono, fontSize: 12, color: varColor }}>
                  <span style={{ fontSize: 9, marginRight: 2 }}>{pctVar > 0 ? '\u25B2' : pctVar < 0 ? '\u25BC' : ''}</span>
                  {pctVar > 0 ? '+' : ''}{pctVar.toFixed(1)}%
                </td>
                <td style={{ textAlign: 'right', padding: '8px 10px' }}>
                  <VarianceIndicator level={level} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
